export default __webpack_public_path__ + "static/media/3.9989caf7.png";